/***************************************************************
5/22/2017
Alexander Self
Profile View
- Displays user profiles
***************************************************************/
import { mapEmployeeForAutoComplete, onDummyComplete } from '../../../utils';
import { AutoComplete } from '../../inputs';
import { fetchEmployeeProfile, fetchEmployeeProfileByName, uploadProfileImage,
 downloadEmployees } from '../../../actions/profile_actions';
import { findEmployeeByName } from '../../../utils';
import EmployeeList from '../../employee_list';
import EmployeeInfoCard from './employeeInfoCard';
import ProfileCard from './profile_card';
import ContentHeader from './employee_content_header';
import ProfileTabs from './profile_tabs';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, { Component } from 'react';


class ProfileView extends Component {
  render() {
    return (
      <div>
        <div className="row">
          <div className="col s12 m12 l2">
            <AutoComplete id={'employee-profile-list'} label={'Find Employee'}
              data={mapEmployeeForAutoComplete(this.props.employees)} onComplete={onDummyComplete} /><br />
            <button onClick={() => this.props.fetchEmployeeProfileByName(findEmployeeByName(document.getElementById('employee-profile-list').value, this.props.employees))}
              className="btn waves-light waves-effect"
            >
              Fetch
            </button>{'\u00A0'}{'\u00A0'}{'\u00A0'}{'\u00A0'}{'\u00A0'}
            <button className="btn-flat small" onClick={this.props.downloadEmployees}>Download</button>
            <div className="emp-list">
              <div className="card">
                <EmployeeList employees={this.props.employees.filter((e) => e.employeeStatus === 'Active')} icon={'person'} header={'View Employee'} _class={'green'} onClick={(e) => this.props.fetchEmployeeProfile(e)}
                  isEditOrDelete={true} />
              </div>
            </div> <hr />
          </div>
          <div className="col s12 m12 l10">
            {
              this.props.selectedEmployee.eid ?
                <div className="row">
                  <ContentHeader employee={this.props.selectedEmployee} employees={this.props.employees}
                    fetchEmployeeProfileByName={this.props.fetchEmployeeProfileByName}
                  />
                  <div className="col s12 m4 l4 xl4">
                    <ProfileCard employee={this.props.selectedEmployee} />
                    <EmployeeInfoCard employee={this.props.selectedEmployee} />
                  </div>
                  <div className="col s12 m8 l8 xl8">
                    <ProfileTabs employee={this.props.selectedEmployee} employees={this.props.employees}
                      fetchEmployeeProfileByName={this.props.fetchEmployeeProfileByName}
                      stats={this.props.stats} />
                  </div>
                </div>
                : <div></div>
            }
          </div>
        </div>
      </div>
    )
  }
}



function mapStateToProps(state) {
  return {
    user: state.auth.user,
    employees: state.profile.employees,
    selectedEmployee: state.profile.view.selectedEmployee,
    stats: state.profile.view.selectedEmployee.stats
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchEmployeeProfile,
    fetchEmployeeProfileByName,
    uploadProfileImage,
    downloadEmployees
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileView);


/* END */



// WEBPACK FOOTER //
// ./src/components/profiles/view/profile_view.js